<template>
  <Instance
    instance="contact"
    instance-name="Contact"
    :create="d => contactDetails.create(d)"
    :delete="d => contactDetails.remove(d)"
    :update="d => contactDetails.update(d)"
    :get="d => contactDetails.get(d)"
    :upsert="upsert"
    :details="details"
    :columns="columns"
    :hideDelete="!isCommonAdmin"
  />
</template>

<script>
import { BIconPencil, BIconCardText } from 'bootstrap-vue';

import Instance from '../../CRUD/instance';
import { AuthMixin } from '../../../../mixins';
import api from '../../../api';

export default {
  title: 'Contact',
  components: { Instance },
  mixins: [AuthMixin],
  data() {
    return {
      contactDetails: api.contactDetails,
      upsert: [
        { value: 'company', name: 'Company', required: true },
        { value: 'name', name: 'First name', required: true },
        { value: 'surname', name: 'Surname', required: true },
        { value: 'email', name: 'Email', required: true },
        { value: 'telephoneNumber', name: 'Telephone Number', required: true, phoneValidation: true },
        { value: 'mobileNumber', name: 'Mobile Number', phoneValidation: true },
        { value: 'emergencyNumber', name: 'Emergency Number' },
        { value: 'title', name: 'Title' }
      ],
      details: [
        {
          header: 'DETAILS',
          content: [
            { value: 'company', name: 'Company' },
            { value: 'telephoneNumber', name: 'Telephone Number' },
            { value: 'name', name: 'Contact Person', renderRow: row => `${row.title ? `${row.title}, ` : ''} ${row.name} ${row.surname}` },
            { value: 'mobileNumber', name: 'Mobile Number' },
            { value: 'emergencyNumber', name: 'Emergency Number' },
            { value: 'email', name: 'Email' }
          ]
        }
      ]
    };
  },
  methods: {
    columns({ editInstance, instanceDetails }) {
      return [
        {
          field: 'check',
          key: '1',
          type: 'checkbox',
          title: '',
          width: 50,
          align: 'center'
        },
        {
          field: 'company',
          title: this.$translate('Company'),
          key: '9',
          sortBy: '',
          align: 'left'
        },
        {
          field: 'telephoneNumber',
          title: this.$translate('Telephone Number'),
          key: '6',
          sortBy: '',
          align: 'left'
        },
        {
          field: 'name',
          title: this.$translate('Contact Person'),
          key: '3',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return (
              <span>
                {`${row.title ? `${row.title}, ` : ''}`}
                {row.name} {row.surname}
              </span>
            );
          }
        },
        {
          field: 'mobileNumber',
          title: this.$translate('Mobile Number'),
          key: '35',
          sortBy: '',
          align: 'left'
        },
        {
          field: 'emergencyNumber',
          title: this.$translate('Emergency Number'),
          key: '53',
          sortBy: '',
          align: 'left'
        },
        {
          field: 'email',
          title: this.$translate('Email'),
          key: '5',
          sortBy: '',
          align: 'left'
        },
        {
          field: 'actions',
          title: '',
          key: '10',
          renderBodyCell: ({ row }) => {
            return (
              <div class="action-block">
                <div class="details-action" on-click={() => editInstance(row)}>
                  <BIconPencil />
                </div>
                <div class="details-action" on-click={() => instanceDetails(row)}>
                  <BIconCardText />
                </div>
              </div>
            );
          }
        }
      ];
    }
  }
};
</script>
